export default "__VITE_ASSET__745b4cf1__"